import React from "react";
import MovimentacaoFinanceira from "../../components/PortalHome/Contabilidade/MovimentacaoFinanceira";

import "./style.css"

function PageMovimentacaoFinanceira() {

    return (
        <div className="centralizar">
            <MovimentacaoFinanceira />
        </div>
    );
}
export default PageMovimentacaoFinanceira;
